import React from "react";
import { useTranslation } from 'react-i18next';
import "./techstack.css";

const TechStack = () => {
  const { t } = useTranslation();

  const technologies = [
    { name: "React", icon: "⚛️" },
    { name: "Node.js", icon: "🟢" },
    { name: "Docker", icon: "🐳" },
    { name: "MongoDB", icon: "🍃" },
    { name: "AWS", icon: "☁️" },
    { name: "Linux", icon: "🐧" },
    { name: "GitHub", icon: "🐙" },
    { name: "PostgreSQL", icon: "🐘" },
    { name: "Express", icon: "⚡" },
    { name: "Git", icon: "📦" },
  ];

  return (
    <section className="techstack container section" id="techstack">
      <h2 className="section__title">{t('tech_stack_title') || 'Tech Stack'}</h2>
      
      <div className="techstack__grid">
        {technologies.map((tech, idx) => (
          <div key={idx} className="techstack__card" data-aos="zoom-in" data-aos-delay={idx * 50}>
            <div className="techstack__icon">{tech.icon}</div>
            <h4 className="techstack__name">{tech.name}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechStack;
